/* eslint-disable react-func/max-lines-per-function */
/* eslint-disable react-func/max-combined-conditions */
/* eslint-disable max-depth */
/* eslint-disable max-lines */
import React, { useEffect, useRef, useState, ClipboardEvent, useCallback } from 'react';
import classNames from 'classnames/bind';
import * as Sentry from '@sentry/browser';
import { Form, Button, theme, Flex, Popover, Checkbox } from '@fuxi/eevee-ui';
import { InfoCircleFilled, PlusOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { v4 as uuid } from 'uuid';
import { useDrop, useKeyPress, useLocalStorageState, useSize, useDeepCompareEffect } from 'ahooks';
import { debounce, isEmpty, isNil, isString, throttle } from 'lodash-es';
import { ReactImageEditor, findPluginByName, EditorMode, ImagePlugin } from '@fuxi/react-img-editor';
import useAntStaticComponent from 'common/hooks/useAntStaticComponent';
import { getPreviewTypeAndUrl } from 'common/utils/versionDetail';
import { ExportFileType, FileACL, TaskMode, TaskPermissionType } from 'common/types';
import { sendEvent } from 'common/tracker';
import { CustomEvent } from 'common/tracker/custom-event';
import MyIcon from '@/components/MyIcon';
import { CommentSourceType, Comment as CommentType } from '@/types';
import { useTaskEditorContext } from '@/context/TaskEditorContext';
import { useAppSelector, useAppDispatch } from '@/hooks';
import { useCommentContext } from '@/context/CommentContext';
import { eventEmitter } from '@/utils';
import { VideoTransform } from '@/types/playControl';
import { selectUserInfo } from '@/store/user';
import { useTaskDetailContext } from '@/context/TaskDetailContext';
import { compareVersion } from '@/utils/version';
import { PlayerViewerEvent } from '../PlayViewerControl';
import { calculateTime } from '../PlayViewerControl/util';
import { combineImage } from './util';

import styles from './index.module.css';

import '@fuxi/react-img-editor/style.css';
import { UploadManager } from 'common/hooks/upload/UploadManager';
import { RcFile } from 'antd/es/upload';
import { getEnv } from 'common/utils';

const cx = classNames.bind(styles);
type CanvasSize = {
  width: number;
  height: number;
};
export const EXCEED_RATIO = 0.3;
interface CommentToolLightProps {
  parentRef: React.MutableRefObject<HTMLDivElement>;
  getCurrentFrameRate: () => number;
  getCurrentTakeIndex: () => number;
  getCurrentFrameIndex: () => number;
  getCurrentTakeName: () => string;
  frameIndex: number;
  takeIndex?: number;
  playerTransform: VideoTransform;
  toolbarWrapper: React.MutableRefObject<HTMLDivElement>;
  isEventDisabled?: boolean;
  showToolbar?: boolean;
  isDrawDisabled?: boolean;
  enabled: boolean;
}
export interface CommentToolRef {
  saveAnnotation: (params: {
    attachment;
    content;
    isChecked;
    onSuccess?;
    onError?;
    mustSaveStage?: boolean;
  }) => Promise<any> | undefined;
  restoreAnnotation: (comment: CommentType, canEdit: boolean) => void;
  clearAnnotation: () => void;
  updateAnnotation: ({ comment }) => Promise<any> | undefined;
}

const CommentToolLight = React.forwardRef<CommentToolRef, CommentToolLightProps>(
  (
    {
      parentRef,
      frameIndex,
      takeIndex,
      getCurrentFrameRate,
      getCurrentTakeIndex,
      getCurrentTakeName,
      getCurrentFrameIndex,
      playerTransform,
      toolbarWrapper,
      isEventDisabled,
      showToolbar,
      isDrawDisabled,
      enabled,
    },
    ref,
  ) => {
    const { message: antMessage } = useAntStaticComponent();
    const dispatch = useAppDispatch();
    const { token } = theme.useToken();
    const userInfo = useAppSelector(selectUserInfo);

    const {
      setMode,
      id,
      versionId,
      exportFile,
      previewType,
      setPreviewType,
      curVersion,
      cachedPreviewType,
      getCachedComment,
      clearCachedComment,
      modelViewerHide,
      setModelViewerHide,

      setMiniSnapShot,
      setDisableQuery,
      isAnnotationShow,
      setIsAnnotationShow,
      takePlayerCtrlSnapShot,
      isPlayerPause,
      setIsPlayerPause,
      fileList, //预览文件列表
      currentIndex, // 当前预览的文件
      currentFile,
      snapShotRef,
      editorMode,
      setEditorMode,
      onPaletteEnable,
      playerCtrRef,
      fileIdByCurrentIndex,
    } = useTaskEditorContext();
    const {
      saveComment,
      updateComment,
      curComment,
      setIsEditing,
      setIsPreviewing,
      isPreviewing,
      isInspecting,
      setIsInspecting,
    } = useCommentContext();

    const { projectCode, stage, roleInfo } = useTaskDetailContext();
    const { permission } = roleInfo || {};
    const um = useRef<UploadManager>(new UploadManager({ autoUpload: true }));
    const stageRef = useRef<any>();
    const commentToolContainerRef = useRef<any>();
    const isRestoredRef = useRef<boolean>(false);
    const isSavingRef = useRef<boolean>(false);
    const commentToolSize = useSize(commentToolContainerRef);
    const uploadPluginRef = useRef<any>(new ImagePlugin());
    const drawParamsRef = useRef<any>();
    const playViewerHandler = useRef<any>();

    const [mainImageObj, setMainImageObj] = useState<HTMLImageElement | undefined>();
    const [defaultStage, setDefaultStage] = useState<string | undefined>();
    const [defaultImages, setDefaultImages] = useState<Record<string, string>>({});
    const [defaultPluginName, setDefaultPluginName] = useState(isInspecting ? '' : 'pen');
    // const [canvasSize, setCanvasSize] = useState<CanvasSize>({
    //   width: 0,
    //   height: 0,
    // });

    const [isDragOver, setIsDragOver] = useState(false);
    const [currentUrl, setCurrentUrl] = useState<string | string[]>(
      exportFile ? (Array.isArray(exportFile) ? exportFile[0] : exportFile) : '',
    );

    // const [attachment, setAttachment] = useState<Array<UploadFile>>([]);
    const [loading, setLoading] = useState(false);
    const [commentStyle, setCommentStyle] = useState({});
    // const [isRestored, setIsRestored] = useState(false);

    const [ignoreCommentAlert, setIgnoreCommentAlert] = useLocalStorageState<boolean>('eeveeCommentLightIgnore', {
      defaultValue: false,
    });
    const [commentForm] = Form.useForm();
    const [isAlertShow, setIsAlertShow] = useState(!ignoreCommentAlert);

    // 还原注释反馈需要用的东西
    const [annotation, setAnnotation] = useState<any>();
    const commentSize = useRef({ width: 0, height: 0, maxWidth: 0, maxHeight: 0 });
    const domScale = useRef({ x: 1, y: 1 });

    useKeyPress('x', () => {
      toggleInspecting();
    });

    const asyncServiceFn = (file: File) => {
      // return service.upload.uploadFileByProxy(file, 'TASK_MATERIAL_LIBRARY', false);
      // add uuid to file
      const { fosHost } = getEnv();
      return new Promise((resolve, reject) => {
        Object.assign(file, {
          uid: uuid(),
        });
        um.current.add(file as RcFile, {
          params: {
            acl: FileACL.Public,
          },
          onFinished: (res, file) => {
            // resolve(res.url);
            // 替换proxy-host 为fos域名
            // resolve(res.url.replace(/proxy-host/g, fosHost));
            const url = res.url.replace(/\/proxy-host/, fosHost);
            console.log('url', url, fosHost);
            resolve(url);
          },
          onFailed: (err) => {
            reject(err);
          },
        });
      });
    };
    const handleImagePick = async (file: File) => {
      try {
        const curDrawParams = drawParamsRef.current();
        uploadPluginRef.current.onUploaded(
          {
            ...curDrawParams,
            refImage: {
              file,
              createTime: dayjs().format('YYYY-MM-DD HH:mm:ss'),
              createUser: userInfo?.nickName ?? '',
            },
          },
          asyncServiceFn,
        );
      } catch (err) {
        console.error(err);
      }
    };

    function setStage(stage) {
      stageRef.current = stage;
    }

    const getDrawEventParams = (params) => {
      drawParamsRef.current = params;

      onResize();
    };

    const onCancel = () => {
      setLoading(false);
      //清空画布
      clearStage();

      isRestoredRef.current = false;
      isSavingRef.current = false;
      setMode(TaskMode.Preview);
      setPreviewType(cachedPreviewType);
      setIsAnnotationShow(false);
      setModelViewerHide(false);
      clearCachedComment();
      setMiniSnapShot(null);
      setDisableQuery(false);
      // dispatch(setNeedsRebuildAnnotation(false));
      setDefaultStage(undefined);
      setAnnotation(undefined);
      setIsEditing(false);

      setIsPreviewing(false);
    };

    const onAddError = () => {
      antMessage.error('新建反馈失败');
      onCancel();
    };

    const clearStage = () => {
      isRestoredRef.current = false;
      isSavingRef.current = false;
      if (drawParamsRef.current) {
        drawParamsRef.current().clearStage();
        setDefaultImages({});
      }
      setAnnotation(undefined);
    };

    const restoreStage = (comment: CommentType, canEdit: boolean) => {
      isRestoredRef.current = true;
      setIsPlayerPause(true);
      if (comment.assetPosition.isLinkedAnnotation && comment.annotation) {
        const obj = comment.annotation;
        setAnnotation({ mainImage: '', stage: obj.stage, images: obj.images ?? {}, pluginName: 'pen' });
        snapShotRef.current[comment.assetPosition.fileId] = comment.assetPosition.snapShot;
      }
    };

    const getFormattedAttachment = (attachment) => {
      if (attachment && Array.isArray(attachment)) {
        return attachment.map((item) => {
          // return { url: item.url, fileName: item.name, size: item.size };
          return { ...(item.response ?? {}), ...item, fileSize: item.size.toString() };
        });
      } else {
        return [];
      }
    };

    const onEditorSave = async ({
      attachment,
      content,
      isChecked = true,
      onSuccess = (data: any) => {},
      onError = (err: any) => {},
      mustSaveStage = false,
    }) => {
      // const fileIndex = currentIndex;
      if (isRestoredRef.current && !mustSaveStage) {
        onCancel();
        return Promise.resolve();
      }
      isRestoredRef.current = false;
      const { drawLayer, imageLayer } = drawParamsRef.current();
      const fileInfo = getPreviewTypeAndUrl(currentFile!);
      let url = fileInfo.url ?? '';
      const drawParams = drawParamsRef.current();
      drawParams.blurPalette();

      if (
        !drawParamsRef.current() ||
        (drawLayer?.getChildren().length === 0 &&
          imageLayer?.getChildren().length === 0 &&
          (!content || content.length === 0))
      ) {
        onCancel();
        return Promise.resolve();
      }

      try {
        setLoading(true);

        const fileId = currentFile?.uuid ?? fileIdByCurrentIndex;
        if (isChecked && fileId) {
          let snapshot = snapShotRef.current[fileId];
          // 查看snapShotRef是否存在当前文件的快照
          if (!snapshot?.image) {
            snapshot = await takeSnapShot(fileId);
            snapShotRef.current[fileId] = snapshot;
          }
          activeCommentTool();
          const frameIndex = getCurrentFrameIndex();
          const frameRate = getCurrentFrameRate();
          const frameTime = calculateTime({ frameIndex: frameIndex, frameRate: frameRate });
          const formattedAttachment = getFormattedAttachment(attachment);
          if (drawParamsRef.current()) {
            const stage = stageRef.current;

            //判断stage宽高不能为0
            if (stage.width() === 0 || stage.height() === 0) {
              Sentry.captureException(new Error('stage width or height is 0'));
              antMessage.error('当前画布宽高为0，无法保存反馈，请刷新页面或切换文件重试');
              return Promise.reject();
            }

            const canvasUrl = stage.toDataURL({
              imageSmoothingEnabled: false,
              x: 0,
              y: 0,
              width: commentSize.current.width,
              height: commentSize.current.height,
            });
            const stageObject = stage.toObject();
            const images = Object.fromEntries(drawParams.imageMap || new Map());
            const hasAnnotation = drawLayer?.getChildren().length !== 0 || imageLayer?.getChildren().length !== 0;

            const obj = {
              content,
              preview: '',
              annotation: {
                mainImage: '',
                stage: stageObject,
                images,
              },
              attachment: formattedAttachment,
              assetPosition: {
                isLinkedAnnotation: isChecked,
                fileId,
                // url,
                fileName: fileInfo.fileName,
                frameTime,
                takeIndex: getCurrentTakeIndex(),
                frameIndex,
                snapShot: {
                  images: '',
                  params: snapshot?.params ?? null,
                },
                playerTransform: {
                  transX: 0,
                  transY: 0,
                  width: playerTransform.width,
                  height: playerTransform.height,
                  scale: 1,
                },
                takeName: getCurrentTakeName(),
                hasAnnotation,
              },
            };

            onCancel();
            return combineImage({
              frontUrl: canvasUrl,
              backUrl: snapshot?.image ?? '',
            }).then((blob) => {
              clearSnapShot();
              saveComment({
                jsonObj: obj,
                versionId,
                imageBlob: blob,
                id,
                type: CommentSourceType.Video,
                versionName: curVersion?.version,
                onSuccess: (data) => {
                  setLoading(false);
                  // antMessage.success('新建反馈成功');
                  onSuccess(data);
                  // 在snapshot删除当前文件的快照
                  if (snapShotRef.current) {
                    snapShotRef.current[fileId!] = undefined;
                  }
                },
                onError,
              });
            });
          }
        }

        //没有绘制内容，查看有没有文本内容，快去保存
        if (content && content.length > 0) {
          const formattedAttachment = getFormattedAttachment(attachment);
          const obj = {
            content,
            preview: '',
            annotation: {
              mainImage: '',
              stage: {},
              images: {},
            },
            attachment: formattedAttachment,
            assetPosition: { isLinkedAnnotation: false, fileName: '' },
          };
          clearSnapShot();
          onCancel();
          return Promise.resolve(
            saveComment({
              jsonObj: obj,
              versionId,
              id,
              imageBlob: null,
              type: CommentSourceType.Text,
              versionName: curVersion?.version,
              onSuccess: (data) => {
                setLoading(false);
                onSuccess(data);
                // 在snapshot删除当前文件的快照
                if (snapShotRef.current) {
                  snapShotRef.current[fileId!] = undefined;
                }
              },
              onError,
            }),
          );
        }
        onCancel();
        // }
      } catch (err) {
        console.error(err);
        antMessage.error(JSON.stringify(err));
        onAddError();
        setLoading(false);
        return Promise.reject(err);
      }
    };

    // eslint-disable-next-line react-func/max-lines-per-function
    const update = async ({ comment }) => {
      const fileIndex = currentIndex;
      if (isNil(fileIndex) || fileIndex === -1 || !currentFile) {
        antMessage.error('没有找到对应的文件');
        return false;
      }
      setLoading(true);

      const file = currentFile;

      const indexFileKey = 'uuid';
      const fileId = file[indexFileKey] as string;

      const { url } = getPreviewTypeAndUrl(file);
      const { attachment, content, uniqueId, type, assetPosition } = comment;

      let { isLinkedAnnotation } = assetPosition;
      const formattedAttachment = getFormattedAttachment(attachment);

      let snapshot = await takeSnapShot(fileId);

      const obj = {
        ...comment,
        attachment: formattedAttachment,
      };

      try {
        if (isLinkedAnnotation) {
          activeCommentTool();
          const frameIndex = getCurrentFrameIndex();
          const frameRate = getCurrentFrameRate();
          const frameTime = calculateTime({ frameIndex: frameIndex, frameRate: frameRate });
          if (drawParamsRef.current()) {
            const stage = stageRef.current;
            const drawParams = drawParamsRef.current();
            const { drawLayer, imageLayer } = drawParams;

            drawParams.blurPalette();
            //判断stage宽高不能为0
            if (stage.width() === 0 || stage.height() === 0) {
              Sentry.captureException(new Error('stage width or height is 0'));
              antMessage.error('当前画布宽高为0，无法保存反馈，请刷新页面或切换文件重试');
              return Promise.reject();
            }
            const canvasUrl = stage.toDataURL({
              imageSmoothingEnabled: false,
              x: 0,
              y: 0,
              width: commentSize.current.width,
              height: commentSize.current.height,
            });
            const stageObject = stage.toObject();
            const images = Object.fromEntries(drawParams.imageMap || new Map());

            const hasAnnotation = drawLayer?.getChildren().length !== 0 || imageLayer?.getChildren().length !== 0;

            obj['annotation'] = {
              mainImage: '',
              stage: stageObject,
              images: images,
            };

            obj['assetPosition'] = {
              ...comment.assetPosition,
              fileId,
              url,
              fileName: file.fileName,
              takeIndex: getCurrentTakeIndex(),
              frameIndex,
              frameTime,
              takeName: getCurrentTakeName(),
              snapShot: {
                images: '',
                params: snapshot?.params ?? null,
              },
              hasAnnotation,
            };
            const blob = await combineImage({
              frontUrl: canvasUrl,
              backUrl: snapshot?.image ?? '',
            });
            onCancel();

            await updateComment({ reviewId: comment.uniqueId, taskId: id, comment: obj, imageBlob: blob });
          } else {
            antMessage.error('画板没有初始化，请刷新后重试');
            return false;
          }
        } else {
          obj['assetPosition'] = {
            ...comment.assetPosition,
            isLinkedAnnotation: false,
            fileId: null,
            url: null,
            fileName: null,
          };
          onCancel();
          await updateComment({ reviewId: comment.uniqueId, taskId: id, comment: obj, imageBlob: null });
        }
      } catch (err) {
        setLoading(false);
        antMessage.error('反馈发布失败');
      }
    };

    const changePlugin = (pluginName: string, trigger = true) => {
      if (!drawParamsRef.current) {
        return;
      }
      const { plugins, handlePluginChange, imageMap } = drawParamsRef.current();
      const plugin = findPluginByName(plugins, pluginName);
      handlePluginChange(plugin, trigger);
    };
    useDrop(commentToolContainerRef, {
      onFiles: (files, e) => {
        if (files[0].type.match('^image/')) {
          changePlugin('image', false);
          setIsDragOver(false);
          setTimeout(async () => {
            //等待内部状态切换完毕
            await handleImagePick(files[0]);
          }, 500);
        } else {
          setIsDragOver(false);
          antMessage.error('仅支持引用图片类型文件');
        }
      },
      onDrop: () => setIsDragOver(false),
      onDragEnter: (e) => {
        if (e?.dataTransfer?.types?.[0] === 'Files') {
          setIsDragOver(true);
        }
      },
      onDragLeave: () => setIsDragOver(false),
    });

    const toggleInspecting = async () => {
      if (isEventDisabled) {
        return;
      }

      const { handlePluginChange, blurPalette } = drawParamsRef.current();
      // if (isInspecting) {
      playerCtrRef.current?.startRender && playerCtrRef.current.startRender();
      // changePlugin('pen');
      // } else {
      handlePluginChange(null, false);
      blurPalette();
      // }

      setIsInspecting(true);
      stageRef.current.container().tabIndex = 1;
      stageRef.current.container().focus();
      // if (!isInspecting) {
      //   await takeSnapShot(fileIdByCurrentIndex);
      // }
    };

    // useEffect(() => {
    //   if (isPreviewing) {
    //     setIsInspecting(true);
    //     const { handlePluginChange } = drawParamsRef.current();
    //     handlePluginChange && handlePluginChange(null, false);
    //     return;
    //   }
    // }, [isPreviewing]);

    const onExit = () => {
      //清空表单
      commentForm.resetFields();
      onCancel();
    };

    const activeCommentTool = (pluginName?: string) => {
      if (pluginName === 'image') {
        setIsPlayerPause(true);
        if (playerCtrRef.current?.pause) {
          playerCtrRef.current?.pause();
        }
      }
    };
    const onDraw = (pluginName: string) => {
      setIsPlayerPause(true);
      if (playerCtrRef.current?.pause) {
        playerCtrRef.current?.pause();
      }

      if (playerCtrRef.current?.stopRender) playerCtrRef.current?.stopRender();
    };
    // 根据fileId截图
    const takeSnapShot = async (fileId: string) => {
      if (playerCtrRef.current && playerCtrRef.current.startRender) {
        playerCtrRef.current.startRender();
      }

      const snaps = await takePlayerCtrlSnapShot(fileId);
      return snaps;

      // return { image: '', params: {} };
    };

    const clearSnapShot = (fileId?: string) => {
      if (!fileId) {
        return;
      }
      snapShotRef.current[fileId] = undefined;
    };

    const is030DCCVersion = useCallback(() => {
      //判断curVersion?.qualityInspection?.dccVersion大于等于0.3.0版本
      return compareVersion(curVersion?.qualityInspection?.dccVersion ?? '0.0.0', '0.3.0');
    }, [curVersion]);
    const onDrawEnd = debounce(
      async (pluginName: string) => {
        // if (playerCtrRef.current?.startRender) {
        //   playerCtrRef.current?.startRender();
        // }
        const indexFileKey = 'uuid';
        if (fileList[currentIndex]) {
          const fileId = fileList[currentIndex][indexFileKey];
          const snaps = await takeSnapShot(fileId);
          snapShotRef.current[fileId] = snaps;
        }
      },
      200,
      { leading: true, trailing: false },
    );
    const toggleToPalette = () => {
      onPaletteEnable();
    };
    const prefixRender = () => {
      return (
        <Popover
          autoAdjustOverflow={true}
          open={isAlertShow}
          trigger={['click']}
          onOpenChange={(open: boolean) => setIsAlertShow(false)}
          overlayClassName={cx('comment-tool-ant-popover')}
          content={
            <div>
              <InfoCircleFilled style={{ color: token.colorPrimary }} />
              <span className={cx('comment-tool-alert-text')}>切换画板，绘制内容会自动保存</span>
              <Checkbox
                checked={ignoreCommentAlert}
                onChange={(e) => setIgnoreCommentAlert(e.target.checked)}
                className={cx('comment-tool-ant-checkbox')}>
                下次不再提醒
              </Checkbox>
              <Button type="link" onClick={() => setIsAlertShow(false)}>
                我知道了
              </Button>
            </div>
          }>
          <MyIcon
            onClick={toggleInspecting}
            key="icon-expand-text"
            title={!isInspecting ? '查看(x)' : '禁用(x)'}
            className={cx(`toolbar-icon`, isInspecting ? 'toolbar-icon-activated' : '')}
            icon="3-d-rotation"
            size="24px"
          />
        </Popover>
      );
    };
    const suffixRender = () => {
      return (
        <>
          <Flex gap="8px" alignCenter>
            {previewType === ExportFileType.Babylon && (
              <span key="change-to-palette" className={cx('toolbar-icon', 'toolbar-icon-toggle')}>
                <Button type="link" onClick={toggleToPalette} className={cx('button')}>
                  <MyIcon icon="zhuanhuan-1" size={24} />
                  <span>旧版反馈</span>
                </Button>
              </span>
            )}
          </Flex>
        </>
      );
    };
    const is3D = useCallback((previewType) => {
      if (!previewType) {
        return false;
      }
      return (
        previewType === ExportFileType.Animation ||
        previewType === ExportFileType.Babylon ||
        previewType === ExportFileType.TurnTable
      );
    }, []);
    const onResize = () => {
      if (stageRef.current && parentRef.current) {
        const { offsetWidth, offsetHeight } = parentRef.current;
        const is3DAsset = is3D(previewType);
        let scale = is3DAsset ? offsetHeight / 1024 : 1;

        const compute = {
          width: offsetWidth * (previewType === ExportFileType.Image ? 1 + EXCEED_RATIO * 2 : 1),
          height: offsetHeight * (previewType === ExportFileType.Image ? 1 + EXCEED_RATIO * 2 : 1),
          maxWidth: is3DAsset
            ? playerTransform.width / scale
            : offsetWidth * (previewType === ExportFileType.Image ? 1 + EXCEED_RATIO * 2 : 1),
          maxHeight: is3DAsset
            ? playerTransform.height / scale
            : offsetHeight * (previewType === ExportFileType.Image ? 1 + EXCEED_RATIO * 2 : 1),
        };
        commentSize.current = compute;

        domScale.current = { y: scale, x: scale };
        if (drawParamsRef?.current) {
          const { stage, drawLayer, imageLayer } = drawParamsRef?.current?.();

          const offsetWidth = commentSize.current.width;
          const offsetHeight = commentSize.current.height;
          const scale = domScale.current.y;
          stage.offsetX(-offsetWidth / 2);
          stage.offsetY(-offsetHeight / 2);
          stage.width(offsetWidth);
          stage.height(offsetHeight);

          drawLayer.scale({ x: scale, y: scale });
          imageLayer.scale({ x: scale, y: scale });

          stage.batchDraw();
        }

        // }
      }
    };

    useDeepCompareEffect(() => {
      if (playerTransform) {
        // setCanvasSize({
        //   width: playerTransform.width,
        //   height: playerTransform.height,
        // });
        onResize();
        setCommentStyle({
          pointerEvents:
            permission?.includes(`${projectCode}.${TaskPermissionType.TaskReview}`) && !isInspecting && !isDrawDisabled
              ? 'auto'
              : 'none',
          left: previewType === ExportFileType.Image ? `-${playerTransform.width * EXCEED_RATIO}px` : '0px',
          top: previewType === ExportFileType.Image ? `-${playerTransform.height * EXCEED_RATIO}px` : '0px',
        });
      }
    }, [playerTransform, isInspecting, isDrawDisabled, permission, projectCode, parentRef.current]);

    useDeepCompareEffect(() => {
      //针对动画的情况，需要监听父容器的变化，居中缩放画布
      onResize();
      // }
    }, [commentToolSize, previewType]);

    useEffect(() => {
      let parsedAnnotation;
      if (annotation) {
        if (isString(annotation)) {
          parsedAnnotation = JSON.parse(annotation);
        } else {
          parsedAnnotation = annotation;
        }

        if (parsedAnnotation.stage) {
          let stage;
          if (isString(parsedAnnotation.stage)) {
            stage = parsedAnnotation.stage;
          } else {
            stage = JSON.stringify(parsedAnnotation.stage);
          }

          setDefaultStage(stage);
          if (annotation.images && !isEmpty(annotation.images)) {
            setDefaultImages(annotation.images);
          }
        }
        setIsAnnotationShow(true);
      }
    }, [annotation]);

    useEffect(() => {
      const uploadFromLocal = async () => {
        if (isInspecting) {
          return;
        }
        try {
          const arrFileHandle = await window.showOpenFilePicker({
            types: [
              {
                description: 'Images',
                accept: {
                  'image/*': ['.png', '.gif', '.jpeg', '.jpg', '.webp', '.bmp', '.svg'],
                },
              },
            ],
            excludeAcceptAllOption: true,
            multiple: false,
          });

          // 遍历选择的文件
          for (const fileHandle of arrFileHandle) {
            // 获取文件内容
            const fileData = await fileHandle.getFile();
            await handleImagePick(fileData);
          }
        } catch (err) {
          console.error(err);
        }
      };

      ImagePlugin.setUploadHandler(uploadFromLocal);

      const handlePaste = debounce(
        async (e: ClipboardEvent<HTMLInputElement>) => {
          if (isInspecting) {
            return;
          }
          try {
            const target = e.target as HTMLElement;
            if (target.tagName === 'TEXTAREA' || target.tagName === 'INPUT') {
              return;
            }

            const items = e.clipboardData && e.clipboardData.items;
            if (items && items.length) {
              let isValid = false;
              /* eslint-disable max-depth */
              for (let i = 0; i < items.length; i++) {
                if (items[i].kind === 'string') {
                  isValid = true;
                } else if (items[i].kind === 'file' && items[i].type.match('^image/')) {
                  // copy data item as an image file
                  const f = items[i].getAsFile() as File;
                  isValid = true;
                  changePlugin('image', false);
                  setTimeout(async () => {
                    //等待内部状态切换完毕
                    await handleImagePick(f);
                  }, 500);
                }
              }
              if (!isValid) {
                antMessage.error('仅支持粘贴图片类型文件');
              }
            } else {
              throw new Error('当前浏览器不支持访问剪贴板');
            }
          } catch (e: any) {
            antMessage.error(e.message);
          }
        },
        3000,
        { leading: true, trailing: false },
      );
      const pasteHandler = (e) => {
        // e.preventDefault();
        handlePaste(e);
      };
      if (isInspecting && !enabled) {
        //remove event listener
        const drawParams = drawParamsRef?.current?.();
        if (drawParams) {
          drawParams.removeEvents(true);
          changePlugin('');
        }
        document.removeEventListener('paste', pasteHandler);
      } else {
        document.addEventListener('paste', pasteHandler);
        // bind stage event listener
        const drawParams = drawParamsRef?.current?.();
        if (drawParams) {
          drawParams.bindEvents();
        }
      }

      return () => {
        //remove event listener
        const drawParams = drawParamsRef?.current?.();
        if (drawParams) {
          drawParams.removeEvents(true);
        }
        document.removeEventListener('paste', pasteHandler);
      };
    }, [isInspecting, enabled]);

    useEffect(() => {
      eventEmitter.on(PlayerViewerEvent.ClearAnnotation, clearStage);

      // eventEmitter.on(PlayerViewerEvent.SaveAnnotation, onEditorSave);

      return () => {
        eventEmitter.off(PlayerViewerEvent.ClearAnnotation, clearStage);
        // eventEmitter.off(PlayerViewerEvent.SaveAnnotation, onEditorSave);
        playViewerHandler.current = null;
        setMainImageObj(undefined);
      };
    }, []);

    useEffect(() => {
      setCurrentUrl(exportFile ? (Array.isArray(exportFile) ? exportFile[0] : exportFile) : '');
    }, [exportFile]);

    const sendTracker = (data: any) => {
      if (data !== null) {
        setIsInspecting(false);
      }

      sendEvent(CustomEvent.UseCommentTool, {
        et: 'CLK',
        c1: projectCode,
        c2: roleInfo?.originRole,
        c3: curVersion?.parentTaskId, // 父任务id
        c4: curVersion?.uniqueId, //阶段id
        c5: data?.name ?? '',
      });
    };

    React.useImperativeHandle(ref, () => ({
      saveAnnotation: throttle(onEditorSave, 500, { leading: true, trailing: false }),
      updateAnnotation: update,
      restoreAnnotation: restoreStage,
      clearAnnotation: onCancel,
    }));

    return (
      <div className={cx('comment-tool')} ref={commentToolContainerRef} style={commentStyle}>
        {/* <Alert message="Warning Text" type="warning" banner closable /> */}
        {isDragOver && (
          <div className={cx('comment-tool-modal')}>
            <div className={cx('comment-tool-info')}>
              <PlusOutlined /> <span className={cx('comment-tool-text')}>引用当前图片</span>
            </div>
          </div>
        )}
        <ReactImageEditor
          isDebug={false}
          imgWidth={playerTransform.width}
          imgHeight={playerTransform.height}
          images={defaultImages}
          defaultPluginName={defaultPluginName}
          imageObj={mainImageObj}
          width={commentSize.current.width}
          height={commentSize.current.height}
          plugins={[uploadPluginRef.current]}
          showChildren={false}
          showToolbar={showToolbar}
          toolbar={{
            items: {
              plugins: ['pen', 'rect', 'circle', 'arrow', 'text', 'eraser', 'image', '|'],
              others: ['|', 'repeal', 'redo', '|', 'clear'],
            },
          }}
          defaultStage={defaultStage}
          mode={editorMode}
          getStage={setStage}
          crossOrigin="use-credentials"
          setDrawEventParams={getDrawEventParams}
          prefixRender={is3D(previewType) ? prefixRender : undefined}
          // suffixRender={suffixRender}
          onPluginEnter={activeCommentTool}
          onDraw={onDraw}
          onDrawEnd={onDrawEnd}
          domScale={domScale}
          defaultScale={1}
          parentNode={editorMode === EditorMode.ANNOTATION ? (toolbarWrapper.current as HTMLElement) : undefined}
          style={{
            top: '0px',
            left: '50%',
            width: '100%',
            padding: 0,
            borderRadius: '0px',
          }}
          isEditorDisabled={isInspecting}
          maxWidth={commentSize.current.maxWidth}
          maxHeight={commentSize.current.maxHeight}
          // container={commentToolContainerRef.current}
          // onTextInsert={onTextInsert}
          onPluginChange={sendTracker}></ReactImageEditor>
      </div>
    );
  },
);
export default CommentToolLight;
